<template>
  <div class="trigger-attribute-condition">
    <el-select
      class="trigger-attribute-condition__attribute-select"
      v-model="choice.key"
      filterable
      value-key="id"
      @input="onAttributeInput"
    >
      <el-option
        v-for="attr in filteredAttributes"
        :key="attr.id"
        :label="parseAttributLabel(attr)"
        :value="attr.id"
      />
    </el-select>
    <font-awesome-icon
      :icon="['fal', 'arrow-right']"
      class="trigger-attribute-condition__arrow"
    />
    <el-select
      class="trigger-attribute-condition__value-select"
      v-model="choice.value"
      value-key="value"
      filterable
      v-if="attributeValues.length"
    >
      <el-option
        v-for="attrVal in attributeValues"
        :key="attrVal.id"
        :label="attrVal.valueName"
        :value="attrVal.id"
      />
    </el-select>
    <!-- IF OPEN VALUE -->
    <base-input
      class="trigger-attribute-condition__value-input mb-0"
      placeholder="Saisir un mot"
      v-model="input"
      @blur="onValueInput"
      @keyup.enter="onValueInput"
      v-else
    ></base-input>
    <font-awesome-icon
      :icon="['fal', 'trash']"
      class="trigger-attribute-condition__trash"
      @click="$emit('remove')"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'trigger-attribute-condition',
  props: {
    condition: {
      type: Object,
      default: () => ({}),
    },
    source: {
      type: String,
      default: '',
    },
    forbiddenKeys: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    if (this.condition.key === 'md_new_condition') return;
    this.choice = this.condition;
    if (this.choice.type === 'text') {
      this.input = this.choice.value;
    }
  },
  data: () => ({
    i18nPrefix:
      'knowledge.diagnostic-builder.side-bar.triggers.salesforce.case-update',
    isEmpty: false,
    choice: {
      key: null,
      value: null,
    },
    input: null,
  }),
  computed: {
    filteredAttributes() {
      const localForbiddenKeys = this.forbiddenKeys.filter(
        (key) => key !== this.condition.key,
      );
      return this.companyAttributes.filter(
        ({ id, source }) =>
          !localForbiddenKeys.includes(id) && source.includes(this.source),
      );
    },
    getAttributeById() {
      return (attrId) => this.companyAttributes.find(({ id }) => id === attrId);
    },
    focusAttribute() {
      if (!this.choice.key) return null;
      return this.companyAttributes.find(({ id }) => id === this.choice.key);
    },
    attributeValues() {
      if (!this.focusAttribute || !this.focusAttribute.companyAttributeValues)
        return [];
      return this.focusAttribute.companyAttributeValues;
    },
    ...mapState(['companyAttributes']),
  },
  methods: {
    onAttributeInput() {
      this.choice.value = null;
      this.input = null;
    },
    onValueInput() {
      this.choice.value = this.input;
    },
    parseAttributLabel(attribute) {
      if (!attribute) return '';
      let { source, label } = attribute;
      source = source.charAt(0).toUpperCase() + source.slice(1);
      return `${source} - ${label}`;
    },
  },
  watch: {
    choice: {
      handler(newVal) {
        if (!newVal.value || !newVal.key) return;
        const type = this.attributeValues.length ? 'value' : 'text';
        this.$emit('change', { ...newVal, type });
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.trigger-attribute-condition {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 6px 0;

  &__arrow {
    color: $blue-mayday;
    margin: 0 8px;
  }

  &__trash {
    color: $grey-6-mayday;
    margin-left: 12px;
    &:hover {
      color: $red-mayday;
      cursor: pointer;
    }
  }

  &__value-input,
  &__value-select,
  &__attribute-select {
    width: 100%;
  }
}
</style>
